import Vue from 'vue';
import { createHelpers } from 'vuex-map-fields';

import { AUTH_REQUEST, AUTH_LOGOUT, AUTH_SUCCESS, AUTH_ERROR } from '../actions/auth';
import { USER_REQUEST, USER_CLEAR } from '../actions/user';
import { ROUTE_API_SIGN_IN, ROUTE_API_SIGN_OUT } from '@/constants/apiRoutes';

const { getAuthField, updateAuthField } = createHelpers({
  getterType: 'getAuthField',
  mutationType: 'updateAuthField',
});

const state = {
  isAuthenticated: false,
  authStatus: '',
};

const getters = {
  getAuthField,

  isAuthenticated: (state) => {
    return state.isAuthenticated;
  },

  authStatus: (state) => state.authStatus,
};

const mutations = {
  updateAuthField,

  [AUTH_REQUEST]: (state) => {
    state.authStatus = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.authStatus = 'success';
    state.isAuthenticated = !!resp.data.user || !!resp.data.username;
  },
  [AUTH_ERROR]: (state) => {
    state.authStatus = 'error';
    state.isAuthenticated = false;
  },
  [AUTH_LOGOUT]: (state) => {
    state.authStatus = '';
    state.isAuthenticated = false;
  },
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      Vue.axios
        .post(ROUTE_API_SIGN_IN, { user })
        .then((response) => {
          dispatch(USER_REQUEST).then(() => {
            commit(AUTH_SUCCESS, response);
            resolve(response);
          });
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    });
  },
  [AUTH_SUCCESS]: ({ commit }, response) => {
    commit(AUTH_SUCCESS, response);
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(ROUTE_API_SIGN_OUT)
        .then(() => {
          commit(AUTH_LOGOUT);
          dispatch(USER_CLEAR);
          resolve();
        })
        .catch((err) => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
